import { render, staticRenderFns } from "./BackofficeCadastroMedicoMedicosEAssistentesTable.vue?vue&type=template&id=50b067b4&scoped=true"
import script from "./BackofficeCadastroMedicoMedicosEAssistentesTable.vue?vue&type=script&lang=ts"
export * from "./BackofficeCadastroMedicoMedicosEAssistentesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b067b4",
  null
  
)

export default component.exports